import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { procurement } from './../view/procurement/store'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    procurement
  },
  plugins: [createPersistedState()],
  // strict: true, // 开启严格模式  确保state 中的数据只能 mutations 修改
  state: {
    commodity: '',
    MallOrderId: '',
    oldOrderId: ''
  },
  mutations: {
    storeOrderId (state, playload) {
      state.MallOrderId = playload
    },
    clearOrderId (state, playload) {
      state.oldOrderId = state.MallOrderId
      state.MallOrderId = playload
    },
    setCommodity (state, playload) {
      let JSONArr = JSON.parse(playload)

      const toDecimal2 = (x) => {
        var f = parseFloat(x)
        if (isNaN(f)) {
          return false
        }
        var E = Math.round(x * 100) / 100
        var s = E.toString()
        var rs = s.indexOf('.')
        if (rs < 0) {
          rs = s.length
          s += '.'
        }
        while (s.length <= rs + 2) {
          s += '0'
        }
        return s
      }

      const FenToYuan = (data) => {
        let num = data
        num = data * 0.01
        num += ''
        let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
        num = num.replace(reg, '$1')
        num = toDecimal2(num)
        return num
      }
      JSONArr.forEach((item, index) => {
        item.sendAmount = item.amount
        item.amount = FenToYuan(item.amount)
        item.goodsDetailList.forEach((ite, ind) => {
          let str = ''
          let sep = ite.spec_detail
          let spec = JSON.parse(sep)
          for (let key in spec) {
            str = str + key + ':' + spec[key] + ' '
          }
          // ite.unit_price
          ite.unit_prices = FenToYuan(ite.unit_price)
          ite.spec_details = str
        })
      })
      state.commodity = JSONArr
    },
    setIsNewMallOrder (state, comm) {
      console.log('state.commodity start:',JSON.stringify(state.commodity))
      let orderDetail = state.commodity
      orderDetail.forEach((val, index) => {
        orderDetail[index]['isNewMallOrder'] = comm
      })

      state.commodity = orderDetail
      console.log('state.commodity end:',JSON.stringify(state.commodity))
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js